<template>
  <p>Logout</p>
</template>

<script>

import { auth } from '@/main.js'

export default {
  metaInfo: {title: 'Logout'},
  created() {
    auth.signOut()
    this.$router.push({name: 'home'})
  }
}
</script>
